export default __webpack_public_path__ + "static/media/sustentabilidade.8e014898.png";